import loading from "../../../assets/images/loading/sppiner1.gif";
const Loading = (props)=> {
    return(
        <img src={loading} className={props.className} alt="loading" />
    )
}

export default Loading;